import { isCapped } from '../../plans/capRefusal';

/**
 * Plans v2: tasks on the user's own boards, for the + button's task cap —
 * the open board live, the other private boards from the grid summaries.
 *
 * A board opened directly (the grid never loaded) has no summaries yet. On a
 * plan that caps tasks the other boards are then counted from the store first
 * (`listSummaries()`; the answer is a Promise, which handleAddTask waits for),
 * never assumed to be empty. Unlimited plans never wait.
 *
 * @param {{ open: object|null, summaries: object[], summariesLoaded: boolean,
 *   listSummaries: () => Promise<object[]> }} input
 * @returns {number | Promise<number>}
 */
export function ownTaskCount({ open, summaries, summariesLoaded, listSummaries }) {
  const count = (list) => {
    const others = (list || [])
      .filter((b) => b.visibility === 'private' && b.id !== open?.id)
      .reduce((n, b) => n + (b.taskCount || 0), 0);
    return others + (open && open.visibility !== 'team' ? (open.tasks || []).length : 0);
  };
  if (!summariesLoaded && isCapped('tasks')) return listSummaries().then(count);
  return count(summaries);
}
